import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

export interface SuccessMessageData {
  title: string;
  message: string;
  duration?: number;
  showClose?: boolean;
  type?: 'success' | 'info' | 'warning' | 'error';
}

@Component({
  selector: 'app-success-message',
  standalone: true,
  imports: [MatIconModule, MatButtonModule],
  template: `
    <div class="snackbar-message" [class]="data.type">
      <mat-icon>{{ data.type === 'success' ? 'check_circle' : data.type === 'error' ? 'error' : 'info' }}</mat-icon>
      <div>
        <div class="title">{{ data.title }}</div>
        <div class="message">{{ data.message }}</div>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [`
  .snackbar-message { display: flex; align-items: center; gap: 12px; padding: 12px 16px; border-radius: 8px; color: #fff; }
    .snackbar-message.success { background-color: #28a745; }
    .snackbar-message.error { background-color: #dc3545; }
    .snackbar-message.info { background-color: #17a2b8; }
    .title { font-weight: 500; }
    .message { font-size: 0.9rem; opacity: 0.9; }
`]
})
export class SuccessMessageComponent {
  constructor(
    public snackBarRef: MatSnackBarRef<SuccessMessageComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: SuccessMessageData
  ) {}

  getIcon(): string {
    const icons = {
      success: 'check_circle',
      info: 'info',
      warning: 'warning',
      error: 'error'
    };
    return icons[this.data.type || 'success'];
  }

  dismiss(): void {
    this.snackBarRef.dismiss();
  }
}
